import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const RepayMarkAsCancelledEvent = BaseLoanEvent.extend({
  type: z.literal('repayMarkAsCancelled'),
  paymentId: PaymentId,
});
export type RepayMarkAsCancelledEvent = z.infer<typeof RepayMarkAsCancelledEvent>;
